import {
  CASH_COLLECTION_REPORT_REQUEST,
  CASH_COLLECTION_REPORT_SUCCESS,
  CASH_COLLECTION_REPORT_FAILURE
} from "actions/CashCollectionReport/cashCollectionReportAction";

const initialState = {
  cashCollectionReportData: {},
};

export default function cashCollectionReportReducer(
  state = initialState,
  action
) {
  switch (action.type) {
    case 'CASHCOLLECTIONREPORTDATA':
      if (!action.payload) {
        return initialState;
      } else {
        return {
          ...state,
          cashCollectionReportData: action.payload
        };
      }

    default:
      return state;
  }
}